import React from "react";

const getPlaceholder = ({ disabled, readOnly }) => {
  if (readOnly) {
    return "Live transcripts are recorded by documentation reviewers. Knowtex users can't edit this field.";
  }
  if (disabled) {
    return "Select a recording to begin transcribing.";
  }
  return "Type your live transcript here...";
};

export default function LiveTranscriptPanel({
  value = "",
  onChange,
  onCopy,
  copied = false,
  disabled = false,
  readOnly = false,
}) {
  return (
    <div className="flex h-[280px] min-h-0 flex-col rounded-xl bg-white p-4 shadow-knowtex-shadow">
      <div className="flex items-center justify-between gap-3 px-4 py-3 text-white bg-dark-purple rounded-xl">
        <h2 className="text-[20px]">
          Live Transcript{readOnly ? " (read-only)" : ""}
        </h2>
        <button
          type="button"
          onClick={onCopy}
          disabled={disabled || !String(value || "").trim()}
          className="rounded-md bg-white px-3 py-1 text-sm font-semibold text-ktx-purple hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-50"
        >
          {copied ? "Copied" : "Copy"}
        </button>
      </div>
      <textarea
        value={value}
        onChange={onChange}
        disabled={disabled}
        readOnly={readOnly}
        placeholder={getPlaceholder({ disabled, readOnly })}
        className="mt-3 h-full min-h-0 w-full flex-1 resize-none rounded-xl border-none bg-barely-purple p-4 text-ktx-navy focus:outline-none disabled:opacity-60 read-only:cursor-not-allowed read-only:opacity-60"
      />
    </div>
  );
}
